export const fonts = {
	fontFamily: 'FoundersGrotesk',
	fontFamilyTitle: 'FoundersGrotesk',
}
